module.exports = __webpack_public_path__ + "img/img5.a3a7c802.svg";